export const enum BUTTON_SIZE {
  XS = 'xs',
  SM = 'sm',
  MD = 'md',
  LG = 'lg',
  XL = 'xl',
}

export type BUTTON_SIZE_KEY = BUTTON_SIZE[keyof BUTTON_SIZE]

// For CodeSnippet: enum의 이름을 문자열로 매핑하는 객체
export const BUTTON_SIZE_NAMES = {
  xs: 'BUTTON_SIZE.XS',
  sm: 'BUTTON_SIZE.SM',
  md: 'BUTTON_SIZE.MD',
  lg: 'BUTTON_SIZE.LG',
  xl: 'BUTTON_SIZE.XL',
}

export const enum BUTTON_TYPE {
  SOLID = 'solid',
  OUTLINE = 'outline',
  TEXT = 'text',
}

export type BUTTON_TYPE_KEY = BUTTON_TYPE[keyof BUTTON_TYPE]

// For CodeSnippet: enum의 이름을 문자열로 매핑하는 객체
export const BUTTON_TYPE_NAMES = {
  solid: 'BUTTON_TYPE.SOLID',
  outline: 'BUTTON_TYPE.OUTLINE',
  text: 'BUTTON_TYPE.TEXT',
}
